import Banner from '@zenbusiness/zui/Banner';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { DATE_FORMAT } from '#client/constants/date';
import { SUBSCRIPTION_STATUS } from '#client/constants/subscription';
import useSubScriptionContext from '#client/hooks/useSubscriptionContext';
import { BannerWrapperStyled } from '#client/pages/SharedStyles';
import { getDiffTime } from '#client/utils/date';

dayjs.extend(utc);

export default function CancelSubscriptionBanner() {
  const { loading, error, subscriptionStatus, termEndDate } = useSubScriptionContext();

  // We will show banner when subscription has status is cancel renewal or cancel renewal pending
  const isShowCancelSubscriptionBanner = [
    SUBSCRIPTION_STATUS.CANCEL_RENEWAL,
    SUBSCRIPTION_STATUS.CANCEL_RENEWAL_PENDING
  ].includes(subscriptionStatus);

  const dateText = dayjs
    .utc(termEndDate ?? '')
    .local()
    .format(DATE_FORMAT.MOVE_MONEY);
  const diffDay = Math.abs(getDiffTime(termEndDate));

  if (error) {
    return null;
  }

  if (loading) {
    return undefined;
  }
  return isShowCancelSubscriptionBanner ? (
    <BannerWrapperStyled>
      <Banner
        subtitle={`Be sure to transfer out your remaining balance before ${dateText}, or we’ll send it by check up to 60 days after your account is closed.`}
        title={`You have ${diffDay} days left on your banking subscription`}
        variant="alert"
      />
    </BannerWrapperStyled>
  ) : null;
}
